import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useMilitaryChartsDataContext } from './hooks/useMilitaryChartsDataContext';
import { useMemo } from 'react';

export const BattalionEvolutionAnual = () => {
    const { chartData } = useMilitaryChartsDataContext();

    // Transform data to show each company (cia) evolution by year
    const { series, categories } = useMemo(() => {
        const anualData = chartData?.battalionEvolutionAnual || [];
        
        if (!anualData.length) {
            return { series: [], categories: [] };
        }

        // Get all unique companies
        const btlsSet = new Set();
        anualData.forEach(yearData => {
            yearData.batalhoes?.forEach(btl => {
                btlsSet.add(btl.btl);
            });
        });

        // Create series for each company
        const companySeries = Array.from(btlsSet).map(btlName => {
            const data = anualData.map(yearData => {
                const btlsData = yearData.batalhoes?.find(b => b.btl === btlName);
                return btlsData?.total || 0;
            });
            return {
                name: btlName,
                data: data
            };
        });

        // Get years as categories
        const yearsCategories = anualData.map(item => getYearLabel(item.ano_estatistica));

        return {
            series: companySeries,
            categories: yearsCategories
        };
    }, [chartData?.battalionEvolutionAnual]);

    return (
        <SimpleBars
            title={'Ocorrências por Batalhão (Anual)'}
            horizontal={false}
            stacked={true}
            subtitles={categories}
            series={series}
            isMoney={false}
            showDataLabels={true}
        />
    );
};
